import { magentoApi } from "./magentoApi";

// Get the matching customer group by the key opportunity attributes
export function fetchCustomerGroup(
  isMsa,
  externalAccountId,
  opportunityType,
  tenderCode
) {
  return magentoApi.get(
    `canon/customerGroup?isMsa=${
      isMsa ? 1 : 0
    }&externalAccountId=${externalAccountId}&opportunityType=${opportunityType}&tenderCode=${tenderCode}`
  );
}

export async function fetchOpportunity(oid, qid) {
  let result = await magentoApi.get(
    `canon/sfdc/opportunity?oid=${oid}&qid=${qid}`
  );

  // The response can be double encoded by the backend to bypass the undesired behavior of Magento on data object or array.
  if (typeof result === "string") {
    result = JSON.parse(result);
  }

  if (result.Status === "OK") {
    return result.Opportunity;
  } else {
    throw new Error(result.message || "fetchOpportunity() failed");
  }
}
